import React from 'react';
import classnames from 'classnames';
import style from './index.scss';
import { connect } from 'react-redux';
import { BrushLineChart } from '../../../components/ns/BrushChart';
import { nsColorConstants } from '../../../util/GlobalConstant';
import AverageAged from './AverageAged';
import ThroughPut from './ThroughPut';

import { getAnalystThroughputData } from '../../../redux/actions/ns/analystThroughput';

const throughputMeta = {
  colors: [nsColorConstants.throughPut, nsColorConstants.peerAvg]
};

export class AnalystThroughput extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getAnalystThroughputData());
  }

  render() {
    const { analystThroughput } = this.props;
    const data = analystThroughput.data;
    if (data) {
      const throughputData = data.throughput;
      const alertsData = data.aged_alerts;

      const throuMeta = throughputMeta;
      throuMeta.names = throughputData.fields;
      return (
        <div className={style.wrapper}>
          <div className={classnames(style.dashboardChart)}>
            <div className={classnames(['card col-md-12', style.cardWrapper])}>
              <div className={classnames(style.cardHeaderMore)}>
                {data.customer_data.name}
              </div>
              <div className={classnames('card-body', style.cardBodyMore)}>
                <AverageAged data={alertsData} />
                <ThroughPut data={throughputData.data} meta={throuMeta} />
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

function mapStateToProps(state, ownProps = {}) {
  return {
    analystThroughput: state.nsAnalystThroughput
  };
}

function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AnalystThroughput);
